import { BuildFontString } from "../utils/BuildFontString";
import { SetCtxFont } from "../utils/SetCtxFont.js";
import { QElement } from "./QElement";

export class QExcelFieldElement extends QElement {
  constructor() {
    super();
    this.fValue = null;
    this.fFontString = null;
  }

  InitFieldElement(parentPanel, x, y, width, height, fieldName) {
    this.SizeElement(width, height);
    this.PositionElement(x, y);
    this.SetIsSelectable(true);
    this.SetDraggable(true);
    parentPanel.PushElement(this);

    this.fValue = fieldName;

    //	this.SetFillMode(enumFillMode.solidFill);
    //	this.SetFillColor("#FFFFFF");
    //	this.SetBorderStyle(enumElementBorderStyle.singleBorder);
    //	this.SetBorderThickness(1);
    //	this.SetBorderColor("#000000");
  }

  GetFontString() {
    if (this.fFontString == null)
      this.fFontString = BuildFontString("Verdana", 11, this.fIsHeader, false);
    return this.fFontString;
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.fillStyle = "#000000";
    var fontStr = this.GetFontString();
    SetCtxFont(ctx, fontStr);
    var txtHOffset = this.fHorzOffset;
    var txtVOffset = this.fVertOffset;
    ctx.textAlign = "left";
    ctx.textBaseline = "top";

    ctx.fillText(this.fValue, txtHOffset, txtVOffset);
  }
}
